/* Shivving (IE8 is not supported, but at least it won't look as awful)
/* ========================================================================== */

(function (document) {
	var
	head = document.head = document.getElementsByTagName('head')[0] || document.documentElement,
	elements = 'article aside audio bdi canvas data datalist details figcaption figure footer header hgroup mark meter nav output picture progress section summary time video x'.split(' '),
	elementsLength = elements.length,
	elementsIndex = 0,
	element;

	while (elementsIndex < elementsLength) {
		element = document.createElement(elements[++elementsIndex]);
	}

	element.innerHTML = 'x<style>' +
		'article,aside,details,figcaption,figure,footer,header,hgroup,nav,section{display:block}' +
		'audio[controls],canvas,video{display:inline-block}' +
		'[hidden],audio{display:none}' +
		'mark{background:#FF0;color:#000}' +
	'</style>';

	return head.insertBefore(element.lastChild, head.firstChild);
})(document);

/* Prototyping
/* ========================================================================== */

(function (window, ElementPrototype, ArrayPrototype, polyfill) {
	function NodeList() { [polyfill] }
	NodeList.prototype.length = ArrayPrototype.length;

	ElementPrototype.matchesSelector = ElementPrototype.matchesSelector ||
	ElementPrototype.mozMatchesSelector ||
	ElementPrototype.msMatchesSelector ||
	ElementPrototype.oMatchesSelector ||
	ElementPrototype.webkitMatchesSelector ||
	function matchesSelector(selector) {
		return ArrayPrototype.indexOf.call(this.parentNode.querySelectorAll(selector), this) > -1;
	};

	ElementPrototype.ancestorQuerySelectorAll = ElementPrototype.ancestorQuerySelectorAll ||
	ElementPrototype.mozAncestorQuerySelectorAll ||
	ElementPrototype.msAncestorQuerySelectorAll ||
	ElementPrototype.oAncestorQuerySelectorAll ||
	ElementPrototype.webkitAncestorQuerySelectorAll ||
	function ancestorQuerySelectorAll(selector) {
		for (var cite = this, newNodeList = new NodeList; cite = cite.parentElement;) {
			if (cite.matchesSelector(selector)) ArrayPrototype.push.call(newNodeList, cite);
		}

		return newNodeList;
	};

	ElementPrototype.ancestorQuerySelector = ElementPrototype.ancestorQuerySelector ||
	ElementPrototype.mozAncestorQuerySelector ||
	ElementPrototype.msAncestorQuerySelector ||
	ElementPrototype.oAncestorQuerySelector ||
	ElementPrototype.webkitAncestorQuerySelector ||
	function ancestorQuerySelector(selector) {
		return this.ancestorQuerySelectorAll(selector)[0] || null;
	};
})(this, Element.prototype, Array.prototype);

/* Helper Functions
/* ========================================================================== */
let ratecnt = 1;
let qtycnt = 1;
let taxcnt = 1;
let rowcnt = 1;
function generateTableRow() 
{
	let rowdata = $('.inventory tr:last').find('td:eq(1)').data('cnt');
	let ratedata = $('.inventory tr:last').find('td:eq(1)').data('cnt');
	let qtydata = $('.inventory tr:last').find('td:eq(2)').data('cnt');
	let taxdata = $('.inventory tr:last').find('td:eq(3)').data('cnt');
	if(ratedata != undefined || qtydata != undefined || taxdata != undefined)
	{
		ratecnt = ratedata + 1;
		rowcnt = rowdata + 1;
		qtycnt = qtydata + 1;
		taxcnt = taxdata + 1;
	}
	var emptyColumn = document.createElement('tr');
	emptyColumn.className = "quote-row";
	emptyColumn.innerHTML = '<td><a class="cut">-</a><span contenteditable  class="quote-item"></span></td>' +
		'<td data-cnt="'+rowcnt+'"><span data-prefix>$</span><span contenteditable class="quote-rate" id="quote-rate'+ratecnt+'" data-rateid="'+ratecnt+'">0.00</span></td>' +
		'<td data-cnt="'+rowcnt+'"><span contenteditable class="quote-quantity" id="quote-qty'+qtycnt+'" data-qtyid="'+qtycnt+'">0</span></td>' +
		'<td data-cnt="'+rowcnt+'"><span contenteditable class="quote-tax" id="quote-tax'+taxcnt+'" data-taxid="'+taxcnt+'">0</span></td>' +
		'<td><span data-prefix>$</span><span class="quote-totalprice">0.00</span></td>';

	return emptyColumn;
}

function parseFloatHTML(element) {
	return parseFloat(element.innerHTML.replace(/[^\d\.\-]+/g, '')) || 0;
}

function parsePrice(number) {
	return number.toFixed(2).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1,');
}

/* Update Number
/* ========================================================================== */

function updateNumber(e) {
	var
	activeElement = document.activeElement,
	value = parseFloat(activeElement.innerHTML),
	wasPrice = activeElement.innerHTML == parsePrice(parseFloatHTML(activeElement));

	if (!isNaN(value) && (e.keyCode == 38 || e.keyCode == 40 || e.wheelDeltaY)) {
		e.preventDefault();

		value += e.keyCode == 38 ? 1 : e.keyCode == 40 ? -1 : Math.round(e.wheelDelta * 0.025);
		value = Math.max(value, 0);

		activeElement.innerHTML = wasPrice ? parsePrice(value) : value;
	}

	updateInvoice();
}

/* Update Invoice
/* ========================================================================== */

function updateInvoice() {
	var total = 0;
	var cells, price, total, a, i;

	// update inventory cells
	// ======================

	for (var a = document.querySelectorAll('table.inventory tbody tr'), i = 0; a[i]; ++i) {
		// get inventory row cells
		cells = a[i].querySelectorAll('span:last-child');

		// set price as cell[2] * cell[3]
		first = parseFloatHTML(cells[1]) * parseFloatHTML(cells[2]);
				second =parseFloatHTML(cells[3])/100;
				per = first *second;
				price = first + per;

		// add price to total
		total += price;

		// set row total
		cells[4].innerHTML = price;
	}

	// update balance cells
	// ====================

	// get balance cells
	cells = document.querySelectorAll('table.balance td:last-child span:last-child');

	// set total
	cells[0].innerHTML = total;
	let finalamount = (parseFloatHTML(cells[0]) + parseFloatHTML(cells[1])) - parseFloatHTML(cells[2]);
	//alert(finalamount);
	cells[3].innerHTML = finalamount;


	// set balance and meta balance
	//cells[2].innerHTML = document.querySelector('table.meta tr:last-child td:last-child span:last-child').innerHTML = parsePrice(total - parseFloatHTML(cells[1]));

	// update prefix formatting
	// ========================

	/*var prefix = document.querySelector('#prefix').innerHTML;
	for (a = document.querySelectorAll('[data-prefix]'), i = 0; a[i]; ++i) a[i].innerHTML = prefix;
*/
	// update price formatting
	// =======================

	//for (a = document.querySelectorAll('span[data-prefix] + span'), i = 0; a[i]; ++i) if (document.activeElement != a[i]) a[i].innerHTML = parsePrice(parseFloatHTML(a[i]));
}

/* On Content Load
/* ========================================================================== */

function onContentLoad() {
	updateInvoice();

	var
	input = document.querySelector('input'),
	image = document.querySelector('img');

	function onClick(e) {
		var element = e.target.querySelector('[contenteditable]'), row;

		element && e.target != document.documentElement && e.target != document.body && element.focus();

		if (e.target.matchesSelector('.add')) {
			document.querySelector('table.inventory tbody').appendChild(generateTableRow());
		}
		else if (e.target.className == 'cut') {
			row = e.target.ancestorQuerySelector('tr');

			row.parentNode.removeChild(row);
		}

		updateInvoice();
	}

	function onEnterCancel(e) {
		e.preventDefault();

		image.classList.add('hover');
	}

	function onLeaveCancel(e) {
		e.preventDefault();

		image.classList.remove('hover');
	}

	function onFileInput(e) {
		image.classList.remove('hover');

		var
		reader = new FileReader(),
		files = e.dataTransfer ? e.dataTransfer.files : e.target.files,
		i = 0;

		reader.onload = onFileLoad;

		while (files[i]) reader.readAsDataURL(files[i++]);
	}

	function onFileLoad(e) {
		var data = e.target.result;

		image.src = data;
	}

	if (window.addEventListener) {
		document.addEventListener('click', onClick);

		document.addEventListener('mousewheel', updateNumber);
		document.addEventListener('keydown', updateNumber);

		document.addEventListener('keydown', updateInvoice);
		document.addEventListener('keyup', updateInvoice);

		input.addEventListener('focus', onEnterCancel);
		input.addEventListener('mouseover', onEnterCancel);
		input.addEventListener('dragover', onEnterCancel);
		input.addEventListener('dragenter', onEnterCancel);

		input.addEventListener('blur', onLeaveCancel);
		input.addEventListener('dragleave', onLeaveCancel);
		input.addEventListener('mouseout', onLeaveCancel);

		input.addEventListener('drop', onFileInput);
		input.addEventListener('change', onFileInput);
	}
}

window.addEventListener && document.addEventListener('DOMContentLoaded', onContentLoad);

$(document).on("click", "#quotebtn", function(event)
{
	let fileInput = document.getElementById('fileToUpload');
	let filePath = fileInput.value;
	//alert(filePath); 
	if (filePath != '')
	{
		let allowedExtensions = /(\.doc|\.jpg|\.png|\.jpeg|\.zip|\.docx|\.odt|\.pdf|\.tex|\.txt|\.rtf|\.wps|\.wks|\.wpd)$/i;
		if (!allowedExtensions.exec(filePath))
		{
			alert('Invalid file type');
			fileInput.value = '';
			return false;
		}
	}
	let formData = new FormData();
	let totalfiles = document.getElementById('fileToUpload').files.length;
	let MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
	let filesize = 0;
	for (var index = 0; index < totalfiles; index++)
	{
		filesize = parseInt(filesize) + parseInt(document.getElementById('fileToUpload').files[index].size);
	}
	if (filesize > MAX_FILE_SIZE)
	{
		alert("All files combined may only occupy 5MB of space or less");
	}
	else
	{
		for (var index = 0; index < totalfiles; index++)
		{
			formData.append("fileToUpload[]", document.getElementById('fileToUpload').files[index]);
		}
		//alert("fileToUpload");
		console.log(formData);
		let qr = $(".quote-row");
		quote_rows = [];
		wid = $(this).attr("data-wid");
		//alert(wid);
		//let item = (".quote-item").text();
		for (i = 0; i < qr.length; i++)
		{
			quote_line = {};
			quote_line.item = $(qr[i]).find(".quote-item").text().toString();
			quote_line.rate = parseFloat($(qr[i]).find(".quote-rate").text());;
			quote_line.qty = parseFloat($(qr[i]).find(".quote-quantity").text());;
			quote_line.tax = parseFloat($(qr[i]).find(".quote-tax").text());;
			quote_line.total = parseFloat($(qr[i]).find(".quote-totalprice").text());;
			quote_rows.push(quote_line);
		}
		let finalprice = $("#fp").html();
		let discount = $("#dis").html();
		let extra = $("#ext").html();
		//alert(finalprice);
		let note = $('#note').text();
		let ref = $("#refid").text();
		//alert(fp);
		formData.append("discount", discount);
		formData.append("extra", extra);
		formData.append("quote_rows", JSON.stringify(quote_rows));
		formData.append("wid", wid);
		formData.append("note", note);
		formData.append("ref", ref);
		formData.append("finalprice", finalprice);
		if (ref != '' && fp != 0)
		{
			//alert("here");
			$(document).ajaxSend(function() {
				$("#overlay").fadeIn(300);
			});
			$.ajax({
				headers: {
					'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
				},
				type: "post",
				data: formData,
				url:  '/quotedata',
				contentType: false,
				processData: false,
				dataType: 'json',
				success: function(response)
				{
					//$('.quote').html(response.html);
					$("#quotediv").html(response.html);
				}
			}).done(function() {
				setTimeout(function() {
					$("#overlay").fadeOut(300);
				}, 500);
			});
		}
		else
		{
			alert("Please Enter All Details!!")
		}
	}
});

$(document).on("click", "#editquote1", function(event)
{
	var totalfiles = document.getElementById('fileToUpload').files.length;
	var MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
	let existingfilesize = $("#quotefilesize").val();
	let filesize = 0;
	if (existingfilesize != null)
	{
		filesize = existingfilesize;
	}
	for (var index = 0; index < totalfiles; index++)
	{
		filesize = parseInt(filesize) + parseInt(document.getElementById('fileToUpload').files[index].size);
	}
	if (filesize > MAX_FILE_SIZE)
	{
		alert("All files combined may only occupy 10MB of space or less");
	}
	else
	{
		let qr = $(".quote-row");
		quote_rows = [];
		wid = $(this).attr("data-wid");
		//alert(wid);
		//let item = (".quote-item").text();
		let formData = new FormData();
		for (var index = 0; index < totalfiles; index++)
		{
			formData.append("fileToUpload[]", document.getElementById('fileToUpload').files[index]);
		}
		for (i = 0; i < qr.length; i++)
		{
			quote_line = {};
			quote_line.item = $(qr[i]).find(".quote-item").text().toString();
			quote_line.rate = parseFloat($(qr[i]).find(".quote-rate").text());
			quote_line.qty = parseFloat($(qr[i]).find(".quote-quantity").text());
			quote_line.tax = parseFloat($(qr[i]).find(".quote-tax").text());
			quote_line.total = parseFloat($(qr[i]).find(".quote-totalprice").text());
			quote_rows.push(quote_line);
		}
		//alert($("#fp").text());
		let qid = $("#qid").html();
		let finalprice = $("#fp").html();
		let discount = $("#dis").html();
		let extra = $("#ext").html();
		//alert(finalprice);
		let note = $('#note').text();
		let ref = $("#refid").text();
		//alert(ref);
		formData.append("discount", discount);
		formData.append("extra", extra);
		formData.append("quote_rows", JSON.stringify(quote_rows));
		formData.append("qid", qid);
		formData.append("wid", wid);
		formData.append("note", note);
		formData.append("ref", ref);
		formData.append("finalprice", finalprice);
		$(document).ajaxSend(function() {
			$("#overlay").fadeIn(300);
		});
		$.ajax({
			headers: {
				'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
			},
			type: "post",
			data: formData,
			url:  '/updatequote',
			contentType: false,
			processData: false,
			dataType: 'json',
			success: function(response)
			{
				$("#quotediv").html(response.html);
				//$('.quote').html(response.html);
				/*$('.quote-row').remove();
				$("#fp").text('');
				$("#subt").text('');
				$('#note').html('');
				$("#ext").text('0');
				$("#dis").text('0');
				$("#refid").empty();*/
			}
		}).done(function() {
			setTimeout(function() {
				$("#overlay").fadeOut(300);
			}, 500);
		});
	}
});

function numval()
{
	//alert("done");
}


$(document).on("click focus", ".quote-quantity", function(event)
{
	let data = $(this).data('qtyid');
	$("#quote-qty"+data).text('');
});
$(document).on("click focus", ".quote-rate", function(event)
{
	let data = $(this).data('rateid');
	$("#quote-rate"+data).text('');

});
$(document).on("click focus", ".quote-tax", function(event)
{
	let data = $(this).data('taxid');
	$("#quote-tax"+data).text('');
});
$(document).on("click focus", "#ext", function(event)
{
	$("#ext").text('');
});
$(document).on("click focus", "#dis", function(event)
{
	$("#dis").text('');
});